// Client-provided retreat photography (secondary figures AI-softened; J kept in focus)
export const IMG = {
  // Wide boat scene for the full-bleed hero (copy overlaid)
  heroWide:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/44wr226l_J%20Muenz_9.18.24_123.webp",
  // Ruins walk (used beneath the "rest and relaxation" line)
  manifesto:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/3uhm43wd_J%20Muenz_9.18.24_357.webp",
  // J alone, face forward, smiling on the boat (hero portrait)
  heroFace:
    "https://static.prod-images.emergentagent.com/jobs/d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/images/b1b461d43922593a0fd1a729eae436603794be205a86eaed5fa9b822644fefcf.jpeg",
  // J alone, eating on the boat
  heroPortrait:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/s2ed8tr1_J%20Muenz_9.18.24_721.webp",
  // J alone, looking out over the water
  water:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/wsdmwnj8_J%20Muenz_9.18.24_543.webp",
  // Coastal landscape (other women removed)
  landscape:
    "https://static.prod-images.emergentagent.com/jobs/d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/images/63cd349763daffb87fe5f9210f125d6298521f762ed8f0dffcb5c36e561ed759.jpeg",
  // Ancient ruins, no people
  ruins:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/nqq7o4t0_J%20Muenz_9.18.24_671.webp",
  // Bio portrait: J alone (other women removed)
  bio:
    "https://static.prod-images.emergentagent.com/jobs/d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/images/ade49d554d6e223c776b8d217cdb1a559340390d6dd21b6e16bdb15168878100.jpeg",
};

// Every uploaded retreat photo, used across the gallery for a fuller, livelier feel
export const GALLERY = [
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/iu9dqooh_J%20Muenz_9.18.24_311.webp",
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/81m4n1ns_J%20Muenz_9.18.24_3.webp",
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/c0xz1cjs_J%20Muenz_9.17.24_1089.webp",
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/3usm8a2k_J%20Muenz_9.17.24_992.webp",
  "https://customer-assets-4nw71qhi.emergentagent.net/job_cellular-upgrade/artifacts/rk8ssfo8_J%20Muenz_9.17.24_737.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/s2ed8tr1_J%20Muenz_9.18.24_721.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/nqq7o4t0_J%20Muenz_9.18.24_671.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/wsdmwnj8_J%20Muenz_9.18.24_543.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/6x2647mb_J%20Muenz_9.18.24_165.webp",
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_d0cb2cdd-deb9-4ebf-accd-142de8a76c9d/artifacts/xjiu4yre_J%20Muenz_9.18.24_73.webp",
];
